import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-wellLaboHeader text-white" }
const _hoisted_2 = { class: "p-2 h-12 grid grid-cols-12 content-center" }
const _hoisted_3 = { class: "col-span-6 well_labo-title cursor-pointer flex items-center" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon_text = _resolveComponent("base-icon-text")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layouts_auth_width, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", { href: _ctx.wellLaboUrl }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_base_icon_text, {
                  class: "transition-bounce mr-1",
                  iconClass: "text-wellLabo",
                  path: _ctx.mdiPlayCircle
                }, null, 8, ["path"]),
                _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"1.2rem","display":"inline-block","color":"white"} }, " WELL LABO ", -1))
              ])
            ], 8, _hoisted_4)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}